import { render, staticRenderFns } from "./FlightForm.vue?vue&type=template&id=bf4da4f2&scoped=true&"
import script from "./FlightForm.vue?vue&type=script&lang=js&"
export * from "./FlightForm.vue?vue&type=script&lang=js&"
import style0 from "./FlightForm.vue?vue&type=style&index=0&id=bf4da4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4da4f2",
  null
  
)

export default component.exports